import { useNavigate } from "react-router";
import { Helmet } from "@dr.pogodin/react-helmet";
import { createDiscordChannelPageURL, createProfileLinksURL } from "#lib/urls";
import { IDiscordChannel, IDiscordServer } from "#api/discord";
import { SITE_NAME } from "#env/env-vars";
import { KemonoLink } from "#components/links";
import { FavoriteButton } from "#components/favorite-button";

import * as styles from "./styles.module.scss";

interface IProps {
  server: IDiscordServer;
  selectedChannel: IDiscordChannel;
  offset: number;
}

export function ChannelList({ server, selectedChannel, offset }: IProps) {
  const navigate = useNavigate();

  function setOffset(o: number) {
    navigate(String(createDiscordChannelPageURL(server.id, selectedChannel.id, o)));
  }

  return (
    <aside>
      <Helmet>
        <title key="title">{`${selectedChannel.name} — ${server.name} | ${SITE_NAME}`}</title>
      </Helmet>
      <div>
        {server.name}
      </div>
      <ul>
        {server.channels.map(c => (
          <li key={c.id} className={c.id == selectedChannel.id ? styles.active : ""}>
            <KemonoLink url={String(createDiscordChannelPageURL(server.id, c.id))}>
              <img src="/static/discord/hashtag.svg" />
              {c.name}
            </KemonoLink>
          </li>
        ))}
      </ul>
      <footer>
        <span>Offset {offset}</span>
        <div className={styles.buttons}>
          <button onClick={() => setOffset(offset + 150)} disabled={offset + 150 >= selectedChannel.post_count}>Older</button>
          <button onClick={() => setOffset(Math.max(offset - 150, 0))} disabled={offset == 0}>Newer</button>
        </div>
        <div className={styles.postFav}>
          <FavoriteButton service="discord" creatorId={server.id} />
        </div>
        <div>
          <KemonoLink url={String(createProfileLinksURL("discord", server.id))}>Linked Accounts</KemonoLink>
        </div>
      </footer>
    </aside>
  );
};
